import { useEffect, useState } from "react";
import { TiStarburst } from "react-icons/ti";
import { awards } from "../../../components/Data/datas";

const OurAward = () => {
  const [toggle, setToggle] = useState(1);
  const [direction, setDirection] = useState("next");
  const [animating, setAnimating] = useState(false);

  const handleSlide = (id) => {
    setDirection(id > toggle ? "next" : "prev");
    setToggle(id);
  };

  useEffect(() => {
    const Interval = setInterval(() => {
      if (!animating) {
        setDirection("next");
        toggle < awards.length ? setToggle(toggle + 1) : setToggle(1);
      }
    }, 15000);

    return () => clearInterval(Interval);
  }, [toggle, animating]);

  const handleAnimationStart = () => {
    setAnimating(true);
  };

  const handleAnimationEnd = () => {
    setAnimating(false);
  };

  return (
    <div className="flex flex-col gap-8 p-2 sm:px-16 font-[Roboto] pb-10">
      <div className="grid gap-2 grid-cols-[1fr_auto_1fr] p-3 sm:px-10">
        <div className="bg-[#004C97] h-[0.1rem] self-center"></div>
        <TiStarburst className="text-4xl text-[#3b76db]" />
        <div className="bg-[#004C97] h-[0.1rem] self-center"></div>
      </div>
      <h2 className="font-bold sm:text-6xl sm:leading-[0.9] text-2xl text-center">
        Student Ijazahs: <br /> Their Gateway to Authentic Quranic Recitation
      </h2>
      <p>
        An Ijazah is more than just a certificate—it's an official endorsement
        that confirms your mastery of Quranic recitation, linking your learning
        back to the Prophet (ﷺ) through an unbroken chain of transmission. At
        Maqrahaat ul Tanzeel, our Ijazah program is designed to guide you on a
        structured journey toward achieving excellence in recitation.
      </p>
      <div className="relative overflow-hidden h-80">
        {awards.map((award) => (
          <div
            key={award.id}
            className={`absolute w-full h-full transition-all duration-1000 ${
              award.id === toggle
                ? "opacity-100 transform translate-x-0"
                : direction === "next"
                ? award.id < toggle ||
                  (toggle === 1 && award.id === awards.length)
                  ? "opacity-0 transform -translate-x-full"
                  : "opacity-0 transform translate-x-full"
                : award.id > toggle ||
                  (toggle === awards.length && award.id === 1)
                ? "opacity-0 transform translate-x-full"
                : "opacity-0 transform -translate-x-full"
            }`}
            onTransitionStart={handleAnimationStart}
            onTransitionEnd={handleAnimationEnd}
          >
            <img
              src={award.image}
              alt={`Award ${award.id}`}
              className="w-full h-full object-contain"
            />
          </div>
        ))}
      </div>
      <div className="flex gap-2 sm:gap-3 overflow-hidden justify-center">
        {awards.map((slide) => (
          <button
            key={slide.id}
            onClick={() => handleSlide(slide.id)}
            className={`${
              slide.id === toggle ? "bg-[#66B2FF]" : "bg-gray-400"
            } rounded-full outline-none border-none sm:p-[0.3rem] p-[0.2rem] transition-all duration-300 hover:bg-[#3b76db]`}
            aria-label={`Go to slide ${slide.id}`}
          ></button>
        ))}
      </div>

      <p className="font-[Mulish] text-sm w-[80%] mx-auto text-center">
        Embark on your journey toward Quranic mastery with Maqrahaat ul Tanzeel
        and earn an Ijazah that stands as a testament to your commitment and
        excellence.
      </p>
    </div>
  );
};

export default OurAward;
